import { PostExcelWithToken, GetWithToken, DeleteWithToken } from "../lib/request";

/**
 * Upload image as Admin
 */
export const uploadAdminCdnImage = (formData) => {
    return async function (dispatch) {
        const result = await PostExcelWithToken("/v2/admin/upload-cdn", formData);
        return result;
    };
};

/**
 * Get Admin uploaded images list
 */
export const getAdminCdnImages = (query) => {
    return async function (dispatch) {
        const search = query.search || "";
        const limit = query.limit || 10;
        const page = query.page || 1;
        const result = await GetWithToken(
            `/v2/admin/upload-cdn?search=${encodeURIComponent(search)}&limit=${limit}&page=${page}`
        );
        return result;
    };
};

/**
 * Upload image as Merchant
 */
export const uploadMerchantCdnImage = (formData) => {
    return async function (dispatch) {
        const result = await PostExcelWithToken("/v2/merchant/upload-cdn", formData);
        return result;
    };
};

/**
 * Get Merchant uploaded images list
 */
export const getMerchantCdnImages = (query) => {
    return async function (dispatch) {
        const search = query.search || "";
        const limit = query.limit || 10;
        const page = query.page || 1;
        const result = await GetWithToken(
            `/v2/merchant/upload-cdn?search=${encodeURIComponent(search)}&limit=${limit}&page=${page}`
        );
        return result;
    };
};

/**
 * Delete image as Admin
 */
export const deleteAdminCdnImage = (id) => {
    return async function (dispatch) {
        const result = await DeleteWithToken(`/v2/admin/upload-cdn/${id}`);
        return result;
    };
};

/**
 * Delete image as Merchant
 */
export const deleteMerchantCdnImage = (id) => {
    return async function (dispatch) {
        const result = await DeleteWithToken(`/v2/merchant/upload-cdn/${id}`);
        return result;
    };
};
